import SectionTypes from './section.types';

// Create Section Actions
export const createSectionStart = (data: any) => {
	const action = {
		type: SectionTypes.CREATE_SECTION_START,
		payload: data,
	};
	return action;
};

export const createSectionSuccess = (data: any) => {
	return {
		type: SectionTypes.CREATE_SECTION_SUCCESS,
		payload: data,
	};
};

export const createSectionFailure = (error: unknown) => {
	return {
		type: SectionTypes.CREATE_SECTION_FAILURE,
		payload: error,
	};
};

// Update Section Actions
export const updateSectionStart = (data: any) => {
	return {
		type: SectionTypes.UPDATE_SECTION_START,
		payload: data,
	};
};

export const updateSectionSuccess = (data: any) => {
	return {
		type: SectionTypes.UPDATE_SECTION_SUCCESS,
		payload: data,
	};
};

export const updateSectionFailure = (error: unknown) => {
	return {
		type: SectionTypes.UPDATE_SECTION_FAILURE,
		payload: error,
	};
};

// Get Sections By Organisation Actions
export const getSectionsByOrganisationStart = (data: any) => {
	return {
		type: SectionTypes.GET_SECTIONS_BY_ORGANISATION_START,
		payload: data,
	};
};

export const getSectionsByOrganisationSuccess = (data: any) => {
	return {
		type: SectionTypes.GET_SECTIONS_BY_ORGANISATION_SUCCESS,
		payload: data,
	};
};

export const getSectionsByOrganisationFailure = (error: unknown) => {
	return {
		type: SectionTypes.GET_SECTIONS_BY_ORGANISATION_FAILURE,
		payload: error,
	};
};
